import { ITable } from "../../helpers/travel/planTables";
import { FC, Fragment } from "react";

const Table: FC<React.PropsWithChildren<{ data: ITable; additionLabel?: boolean; multiPrice?: boolean; onlyChild?: boolean }>> = ({
  data,
  additionLabel = false,
  multiPrice = false,
  onlyChild = false,
}) => {
  const isRowSubHeading = (rowValue: string) => !rowValue;
  return (
    <table className="flex flex-col shadow-xl rounded-md overflow-hidden bg-white">
      <thead style={additionLabel ? { lineHeight: "15px" } : {}}>
        <tr className="flex justify-between bg-red p-2 text-white font-bold">
          {data.headers.map(header => (
            <Fragment key={header.label}>
              <th style={additionLabel ? { paddingTop: "10px" } : {}}>{header.label}</th>
              <th style={additionLabel ? { textAlign: multiPrice ? "left" : "right", fontSize: multiPrice ? "14px" : "inherit" } : {}}>
                {onlyChild ? header.childValue : header.value}
                {additionLabel && !multiPrice && (
                  <>
                    <br />
                    <span style={{ fontSize: "12px", fontWeight: "normal" }}>
                      <i>{`per ${onlyChild ? "child" : "adult"}`}</i>
                    </span>
                  </>
                )}
                {multiPrice && (
                  <>
                    <span style={{ fontWeight: "normal" }}>
                      <i> per adult</i>
                    </span>
                    <br />
                    <>
                      <span>{header.childValue}</span>
                      <span style={{ fontWeight: "normal" }}>
                        <i> per child</i>
                      </span>
                    </>
                  </>
                )}
              </th>
            </Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.rows.map((row, index) => (
          <tr key={index} className="flex justify-between p-2 odd:bg-white even:bg-grey-lightest">
            <td className={isRowSubHeading(row.cells[1].value) ? "w-full font-bold" : "w-3/5"}>{row.cells[0].value}</td>
            <td className={`text-right whitespace-pre-line ${isRowSubHeading(row.cells[1].value) ? "w-0" : "w-2/5"}`}>{row.cells[1].value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
